import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { gaPageView, applyGaGate } from "@/lib/analytics";
import { captureTouch, captureGaIds } from "@/lib/attribution";

// One standardized GA4 page_view per SPA route change. Admin routes and
// non-production hostnames never reach GA (tag-level disable).
export default function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    applyGaGate(location.pathname);
    captureTouch();
    gaPageView(location.pathname + location.search);
    captureGaIds();
  }, [location.pathname, location.search]);
  return null;
}
